var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInEmployer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    clipPath: "url(#clip0_3553_1976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 1.97474C0 1.40234 0.202708 0.930122 0.608108 0.55808C1.01351 0.186021 1.54055 0 2.18919 0C2.82626 0 3.34169 0.183153 3.73552 0.549494C4.14092 0.927271 4.34363 1.41951 4.34363 2.02626C4.34363 2.57575 4.14672 3.03365 3.7529 3.39999C3.3475 3.77777 2.81467 3.96666 2.15444 3.96666H2.13707C1.49999 3.96666 0.984562 3.77777 0.590734 3.39999C0.196905 3.02222 0 2.54713 0 1.97474ZM0.225869 17V5.52928H4.08301V17H0.225869ZM6.22008 17H10.0772V10.5949C10.0772 10.1942 10.1236 9.88516 10.2162 9.66766C10.3784 9.27843 10.6245 8.9493 10.9546 8.68029C11.2847 8.41126 11.6988 8.27675 12.1969 8.27675C13.4942 8.27675 14.1429 9.14106 14.1429 10.8697V17H18V10.4232C18 8.72894 17.5946 7.44393 16.7838 6.56817C15.973 5.69241 14.9016 5.25454 13.5695 5.25454C12.0753 5.25454 10.9112 5.88989 10.0772 7.16059V7.19494H10.0598L10.0772 7.16059V5.52928H6.22008C6.24324 5.89561 6.25483 7.03466 6.25483 8.94645C6.25483 10.8582 6.24324 13.5427 6.22008 17Z",
    fill: "#58607C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3553_1976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInEmployer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/inEmployer.888ba51c8182e7efeb1ac180e9eb7cce.svg";